<template>
  <div>
    <v-card flat class="pa-1 rounded-lg">
      <v-card-text class="white">
        <v-row :class="{ 'justify-center': $vuetify.breakpoint.xs }" dense>
          <!-- data type: test or production -->
          <v-col cols="12">
            <div class="d-flex flex-wrap">
              <v-radio-group v-model="dataType" hide-details="auto" row>
                <v-radio
                  label="Ver reporte con datos de prueba"
                  value="00"
                ></v-radio>
                <v-radio
                  label="Ver reporte con datos de producción"
                  value="01"
                ></v-radio>
              </v-radio-group>
            </div>
          </v-col>

          <!-- date range filter -->
          <v-col cols="12" sm="8" md="7" lg="6">
            <div
              class="d-flex justify-center justify-sm-left align-center mt-3"
              :class="{
                'flex-no-wrap': !$vuetify.breakpoint.xs,
                'flex-wrap': $vuetify.breakpoint.xs,
              }"
            >
              <date-picker-2
                v-model="date.start"
                class="my-5 mr-sm-3"
                label="Fecha inicio"
              ></date-picker-2>
              <date-picker-2
                v-model="date.end"
                class="my-5"
                label="Fecha fin"
              ></date-picker-2>
              <v-btn
                @click="filterLastSales"
                class="my-2 ml-sm-3"
                color="primary"
              >
                <v-icon>mdi-filter</v-icon>
                Filtrar
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- data table -->
      <DxDataGrid
        :data-source="sales"
        :show-borders="true"
        :column-auto-width="true"
        @exporting="onExporting"
        style="max-height: 600px"
        :paging="{ enabled: false }"
      >
        <DxScrolling
          row-rendering-mode="virtual"
          showScrollbar="always"
          useNative="false"
        />
        <DxExport :enabled="true" />
        <DxColumn data-field="InvoiceType" caption="Tipo de factura" />
        <DxColumn data-field="ID_Invoice" caption="ID Factura" />
        <DxColumn data-field="InvoiceDate" caption="Fecha factura" />
        <DxColumn data-field="InvoiceTime" caption="Hora factura" />
        <DxColumn data-field="ID_Item" caption="ID Producto/Servicio" />
        <DxColumn
          data-field="CodigoAlterno"
          caption="Código alterno principal"
        />
        <DxColumn data-field="ItemType" caption="Tipo" />
        <DxColumn data-field="ItemQuantity" caption="Cantidad" />
        <DxColumn data-field="ItemDescription" caption="Descripción" />
        <DxColumn data-field="ItemUnitPrice" caption="Precio unitario" />
        <DxColumn data-field="ItemDiscount" caption="Descuento" />
        <DxColumn data-field="ItemDiscountPercent" caption="Descuento (%)" />
        <DxColumn data-field="ItemGravada" caption="Total Con Iva" />
        <DxColumn data-field="ItemPriceSinIVA" caption="Total Gravado" />
        <DxColumn data-field="ItemNoSuj" caption="Total No Suj" />
        <DxColumn data-field="ItemExenta" caption="Total Exenta" />
        <DxColumn data-field="ItemIVA" caption="IVA" />
        <DxColumn data-field="WarehouseName" caption="Almacén" />
        <DxColumn data-field="UserName" caption="Usuario" />
        <DxColumn data-field="FullUserName" caption="Nombre del usuario" />
        <DxColumn data-field="FullSellerName" caption="Nombre del vendedor" />
        <DxColumn data-field="EstadoDTE" caption="Estado del DTE" />
        <DxColumn data-field="DiasCredito" caption="Días de crédito" />
        <DxColumn
          data-field="CodigoGeneracion"
          caption="Código de generación"
        />
        <DxColumn data-field="NumeroControl" caption="Número de control" />
      </DxDataGrid>
    </v-card>
    <block v-model="loading"></block>
    <alert v-model="alert.show" :type="alert.type" :title="alert.title">
      {{ alert.message }}
    </alert>
  </div>
</template>

<script>
import moment from "moment";
import DatePicker2 from "../../../components/DatePicker2.vue";
import {
  DxDataGrid,
  DxColumn,
  DxExport,
  DxScrolling,
} from "devextreme-vue/data-grid";
import { printToExcel } from "../../../helpers/printToexcel";

export default {
  name: "LastSales",
  components: { DatePicker2, DxDataGrid, DxColumn, DxScrolling, DxExport },
  props: {
    win: {
      type: Object,
      default: () => ({}),
    },
    customerToShow: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    dataType: "01",
    date: {
      start: "",
      end: "",
    },
    loading: false,
    sales: [],
    alert: {
      show: false,
      type: "error",
      title: "Error",
      message: ""
    }
  }),
  computed: {
    dateYMD() {
      return {
        start: this.formatDate(this.date.start),
        end: this.formatDate(this.date.end),
      };
    },
  },
  methods: {
    showError(message) {
      this.alert.message = message
      this.alert.type = "error"
      this.alert.title = "Error"
      this.alert.show = true
    },
    formatDate(dateDMY) {
      return moment(dateDMY, "DD/MM/YYYY").format("YYYY-MM-DD");
    },
    async filterLastSales() {
      try {
        this.loading = true;
        const params = {
          ID_Customer: this.customerToShow.ID_Customer,
          dataType: this.dataType,
          startDate: this.dateYMD.start,
          endDate: this.dateYMD.end,
        };
        const { data } = await this.$API.customers.getLastSalesByCustomer(
          this.$clone(params)
        );
        this.sales = data.data;
      } catch (err) {
        console.error(err);
        const errorMsg = this.$parseError(err)
        this.showError(`Ha ocurrido un error, intente nuevamente. ${errorMsg}`)
      } finally {
        this.loading = false;
      }
    },
    onExporting(e) {
      printToExcel(
        e,
        `Historial de ventas - ${this.customerToShow.ID_Customer}`,
        null,
        `Historial de ventas - ${this.customerToShow.ID_Customer} - ${this.customerToShow.LegalName}`
      );
    },
  },
  async beforeMount() {
    // set range 15-day range from now backward
    const currentDate = moment();
    this.date.end = currentDate.format("DD/MM/YYYY");
    this.date.start = currentDate.subtract(15, "days").format("DD/MM/YYYY");
    await this.filterLastSales();
  },
  watch: {},
};
</script>
